import React from "react";
import { Box } from "@mui/material";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import TopReasons from "./components/TopReasons";
import EarningsExample from "./components/EarningsExample";
import TrustSection from "./components/TrustSection";
import Testimonials from "./components/Testimonials";
import Referral from "./components/Referral";

const ReferralEarning = () => {
  return (
    <Box sx={styles.container}>
      <HeroSection />
      <HowItWorks />
      <Referral />
      <TopReasons />
      <EarningsExample />
      <TrustSection />
      {/* <Testimonials /> */}
    </Box>
  );
};

const styles = {
  container: {
    maxWidth: "100%",
    margin: 0,
    padding: 0,
  },
};

export default ReferralEarning;
